<template>
    <!-- 银行 -->
    <div id="bankDiv" class="wrap">
        <el-dialog :visible.sync="tradeCenterDivVisible" 
        :before-close="trade_center_dialog_close" v-loading="loading" append-to-body
         element-loading-background="rgba(0, 0, 0, 0.1)"
         element-loading-text="加载中" element-loading-spinner="el-icon-loading">
            <div class="itembg">
              <div id="itemtitle">
                交易中心
              </div>
              <div class="itemSearch">
                  <label>道具名：</label>
                  <input type="text" v-model="itemName"/>
              </div>
              <a class="tc-resell" @click="reSellItems();"><span>重新挂单</span></a>
              <div v-if="null != fantasyTradeCenterItems" id="itemlist">
                <div class="noItems" v-if="tcItemsForMe.length === 0">暂无可交易道具</div>
                <!-- 桌面端：表格 -->
                <div class="tc-table" v-if="tcItemsForMe.length > 0">
                <el-row>
                <el-col :span="4"><span>货品名称</span></el-col>
                <el-col :span="3"><span>货品类型</span></el-col>
                <el-col :span="2"><span>数量</span></el-col>
                <el-col :span="4"><span>价格</span></el-col>
                <el-col :span="2"><span>品质</span></el-col>
                <el-col :span="3"><span>卖家</span></el-col>
                <el-col :span="3"><span>剩余时间</span></el-col>
                <el-col :span="3"><span>操作</span></el-col>
                </el-row>
                <div v-for="item in tcItemsForMe" v-bind:key="item.id" :id="item.id + '_item'">
                  <el-row class="shopItem">
                      <el-col :span="4">
                        <div class="item" @click="toggleShopOpts('shopOpts_' + item.id);">
                          <img :title="item.itemName" :src="ossPath + item.imgSrc">
                          <span>{{item.itemName}}</span>
                          <!-- 保鲜（perish_v1）：交易行必显剩余新鲜度（定价信号） -->
                          <span v-if="foodText(item)" class="trade-food-badge" :class="item.foodState">{{foodText(item)}}</span>
                          <div :id="'shopOpts_' + item.id"
                            v-show="shopOpts == 'showshopOpts_' + item.id" class="shopOptsDiv"
                            @mouseover="showDiv('shopOpts_' + item.id);"
                            @mouseout="hiddenDiv('shopOpts_' + item.id);">
                            <div class="opts">
                              <div class="infoline" v-if="null!=item.itemName && ''!=item.itemName">名称：{{item.itemName}}</div>
                              <div class="infoline" v-if="null!=item.itemTypeName && ''!=item.itemTypeName">类别：{{item.itemTypeName}}</div>
                              <div class="infoline" v-if="null!=item.quality && -1!=item.quality">评分：{{item.quality}}</div>
                              <div class="infoline" v-if="null!=item.strength && -1!=item.strength">体力恢复：{{item.strength}}</div>
                              <div class="infoline" v-if="null!=item.capacity && -1!=item.capacity">容量：{{item.capacity}}</div>
                              <div class="infoline" v-if="null!=item.durability && -1!=item.durability">耐久：{{item.durability}}</div>
                              <div class="infoline" v-if="null!=item.foodExpireAt && ''!=item.foodExpireAt">保鲜期至：{{foodExpireText(item.foodExpireAt)}}<span v-if="foodText(item)">（{{foodText(item)}}）</span></div>
                            </div>
                          </div>
                        </div>
                      </el-col>
                      <el-col :span="3"><span class="itemdesc">{{item.itemTypeName}}</span></el-col>
                      <el-col :span="2"><span>{{item.stackCount}}</span></el-col>
                      <el-col :span="4"><span>{{item.price}}元</span></el-col>
                      <el-col :span="2"><span>{{item.quality==-1?'无':item.quality}}</span></el-col>
                      <el-col :span="3">
                        <span v-if="item.sellerName!=null && item.sellerName.length > 6" :title="item.sellerName">
                          {{item.sellerName.substring(0,5)}}...
                        </span>
                        <span v-else :title="item.sellerName">
                          {{item.sellerName}}
                        </span>
                      </el-col>
                      <el-col :span="3"><span>{{item.remainTime}}</span></el-col>
                      <el-col :span="3">
                        <a v-if="item.sellerId != fantasyUserBO.id && '已过期'!=item.remainTime" @click="buyItem(item.id);"><span>买入</span></a>
                        <span v-else-if="item.sellerId != fantasyUserBO.id && '已过期'==item.remainTime">无法购买</span>
                        <a v-else @click="cancelSellItem(item.id);"><span>取消挂单</span></a>
                      </el-col>
                  </el-row>
                </div>
                </div><!-- /.tc-table -->

                <!-- 移动端：卡片列表（与表头列数解耦，避免表头/数据错位） -->
                <div class="tc-cards" v-if="tcItemsForMe.length > 0">
                  <div class="tc-card" v-for="item in tcItemsForMe" v-bind:key="'m_' + item.id">
                    <img class="tc-thumb" :src="ossPath + item.imgSrc" :alt="item.itemName"
                         @click="mobileDetailItem = item;">
                    <div class="tc-body" @click="mobileDetailItem = item;">
                      <div class="tc-name">
                        {{item.itemName}}
                        <span v-if="foodText(item)" class="trade-food-badge" :class="item.foodState">{{foodText(item)}}</span>
                      </div>
                      <div class="tc-meta">
                        <span class="tc-price">{{item.price}}元</span>
                        <span>×{{item.stackCount}}</span>
                        <span v-if="item.quality != -1">评分 {{item.quality}}</span>
                      </div>
                      <div class="tc-sub">
                        卖家 {{item.sellerName}}<span class="tc-dot">·</span>{{item.remainTime}}
                      </div>
                    </div>
                    <div class="tc-action">
                      <a v-if="item.sellerId != fantasyUserBO.id && '已过期'!=item.remainTime"
                         class="tc-btn" @click="buyItem(item.id);">买入</a>
                      <span v-else-if="item.sellerId != fantasyUserBO.id && '已过期'==item.remainTime"
                            class="tc-disabled">已过期</span>
                      <a v-else class="tc-btn tc-btn-cancel" @click="cancelSellItem(item.id);">取消挂单</a>
                    </div>
                  </div>
                </div>

                <!-- 移动端道具详情浮层（点击卡片弹出，点遮罩关闭） -->
                <div class="tc-detail-mask" v-if="null != mobileDetailItem" @click="mobileDetailItem = null;">
                  <div class="tc-detail-box" @click.stop>
                    <div class="tc-detail-title">
                      <img :src="ossPath + mobileDetailItem.imgSrc">
                      <span>{{mobileDetailItem.itemName}}</span>
                    </div>
                    <div class="tc-detail-line">类别：{{mobileDetailItem.itemTypeName}}</div>
                    <div class="tc-detail-line" v-if="mobileDetailItem.quality != -1">评分：{{mobileDetailItem.quality}}</div>
                    <div class="tc-detail-line" v-if="mobileDetailItem.strength != -1">体力恢复：{{mobileDetailItem.strength}}</div>
                    <div class="tc-detail-line" v-if="mobileDetailItem.capacity != -1">容量：{{mobileDetailItem.capacity}}</div>
                    <div class="tc-detail-line" v-if="mobileDetailItem.durability != -1">耐久：{{mobileDetailItem.durability}}</div>
                    <div class="tc-detail-line" v-if="null != mobileDetailItem.foodExpireAt && '' != mobileDetailItem.foodExpireAt">
                      保鲜期至：{{foodExpireText(mobileDetailItem.foodExpireAt)}}
                      <span v-if="foodText(mobileDetailItem)">（{{foodText(mobileDetailItem)}}）</span>
                    </div>
                    <div class="tc-detail-line">卖家：{{mobileDetailItem.sellerName}}<span class="tc-dot">·</span>{{mobileDetailItem.price}}元<span class="tc-dot">·</span>剩余 {{mobileDetailItem.remainTime}}</div>
                    <div class="tc-detail-close" @click="mobileDetailItem = null;">关闭</div>
                  </div>
                </div>

                <div class="pageDiv">
                <!-- 分页组件 -->
                <Paging 
                    @change="onTradeCenterPageChange"
                    :page-size="size"
                    :total="total"
                    layout="jumper,total"
                    :current-page="curPage"
                />
                </div>
              </div>
              <div class="noItems" v-else>
                  暂无道具
              </div>
              <div style="clear:both"></div>
          </div>
        </el-dialog>
        
    </div>
</template>

<script>
import {getRequest} from '../../utils/api'
import {postRequest} from '../../utils/api'
import Message from 'element-ui/lib/message'
import Paging from '../../components/Paging';
export default {
  name: 'tradeCenter',
  components:{
    Paging
  },
  props:{
    tradeCenterDivVisible: {
      type: Boolean,
      default: false
    },
    fantasyUserBO: Object,
  },
  data() {
    return {
        loading: false,
        size:10,
        total:0,
        curPage:1,
        fantasyTradeCenterItems: null,
        itemName: '',
        shopOpts: "",
        mobileDetailItem: null,
    };
  },
  watch: {
      itemName: {        handler(newVal, oldVal) {
          if (newVal != null) {
            this.itemName = newVal;
            this.getTradeCenterItems();
          }
        }
      },
      tradeCenterDivVisible: {
        handler(newVal) {
          if (newVal === true) {
            this.getTradeCenterItems();
          }
        }
      }
  },
  mounted: function () {
      if (this.tradeCenterDivVisible) {
          this.getTradeCenterItems();
      }
  },
  computed: {
    // 变质商品不上架展示。后端已在列表 SQL 里过滤（hideSpoiled），这里再兜一层，
    // 覆盖「已过期但还没被定时任务回收」的短暂窗口，避免出现点了买入必报错的挂单。
    tcItemsForMe() {
      if (null == this.fantasyTradeCenterItems) return [];
      return this.fantasyTradeCenterItems.filter(item => !this.isSpoiled(item));
    }
  },
  methods: {
    // 判定是否已变质：以后端下发的 foodState 为准，同时兜住「到期时间已过但状态没刷新」的情况
    isSpoiled(item) {
      if (item.foodState === 'spoiled') return true;
      if (!item.foodExpireAt) return false;
      return new Date(item.foodExpireAt).getTime() <= Date.now();
    },
    // 保鲜（perish_v1）：临期/变质文案（交易行必显）
    foodText(item) {
      if (item.foodState === 'spoiled') return '已变质';
      // fresh 或未下发到期时间（永久保鲜）不显示角标
      if (item.foodState === 'fresh' || !item.foodExpireAt) return '';
      const remain = new Date(item.foodExpireAt).getTime() - Date.now();
      if (remain <= 0) return '已变质';
      if (remain >= 86400000) return '剩' + Math.ceil(remain / 86400000) + '天';
      return '剩' + Math.max(1, Math.floor(remain / 3600000)) + '小时';
    },
    foodExpireText(expireAt) {
      const d = new Date(expireAt);
      const pad = n => (n < 10 ? '0' + n : n);
      return (d.getMonth() + 1) + '月' + d.getDate() + '日 ' + pad(d.getHours()) + ':' + pad(d.getMinutes());
    },
    // 移动端点击后显示提示信息
    showTitle(value) {
        this.$notify({
            message: value,
            duration: 6000
        })
    },
    trade_center_dialog_close(){
      this.$emit("trade_center_dialog_close");
    },
    showDiv: function(shopOpts) {
        this.shopOpts = "show" + shopOpts;
    },
    // 移动端友好的切换显示
    toggleShopOpts: function(shopOpts) {
        var key = "show" + shopOpts;
        if (this.shopOpts === key) {
            this.shopOpts = "hidden" + shopOpts;
        } else {
            this.shopOpts = key;
        }
    },
    //当鼠标移动到目标div的子元素上时，会触发子元素的mouseoverDiv方法，设置inDiv = true，这样延迟后的判断条件就不成立，从而继续显示了。
    hiddenDiv: function(shopOpts) {
        this.shopOpts = "hidden" + shopOpts;
    },
    // 刷新交易中心
    getTradeCenterItems: function(){
        this.fantasyTradeCenterItems = null;
        this.mobileDetailItem = null;
        this.loading = true;
        postRequest('/map/tradeCenter/selectTradeCenterItems', {
          "id": 1,
          "itemName": this.itemName,
          "page": this.curPage
        }).then(resp=> {
          this.loading = false;
          if (resp.status == 200) {
            //成功
            var respData = resp.data;
            if (200 == respData.status) {
              if (null != respData.data && null != respData.data.fantasyTradeCenterItems) {
                this.fantasyTradeCenterItems = respData.data.fantasyTradeCenterItems.list;
                this.total = respData.data.fantasyTradeCenterItems.total;
                this.size = respData.data.fantasyTradeCenterItems.pageSize;
                this.curPage = respData.data.fantasyTradeCenterItems.pageNum;
              } else {
                this.fantasyTradeCenterItems = [];
                if (respData.data && respData.data.fantasyTradeCenterItems) {
                  this.total = respData.data.fantasyTradeCenterItems.total;
                  this.size = respData.data.fantasyTradeCenterItems.pageSize;
                  this.curPage = respData.data.fantasyTradeCenterItems.pageNum;
                }
              }
            } else {
              Message.warning(respData.message);
              //Message.error(respData.message);
            }
          } else {
            //失败
            Message.error('查询交易中心失败');
          }
        }, resp=> {
          Message.error('查询交易中心异常');
        });
    },
    onTradeCenterPageChange: function(page) {
      this.curPage = page.curPage;
      this.getTradeCenterItems();
    },
    // 购买道具
    buyItem: function(tradeItemId) {
      var queryData = {
        "id": tradeItemId,
        "centerId": 1
      };
      this.loading = true;
      postRequest('/map/tradeCenter/buyItem', queryData).then(resp=> {
          if (resp.status == 200) {
            //成功
            var respData = resp.data;
            if (200 == respData.status) {
              Message.success("购买成功！");
              this.getTradeCenterItems();
            } else {
              this.loading = false;
              Message.error(respData.message);
            }
          } else {
            //失败
            this.loading = false;
            Message.error('用户非法⊙﹏⊙∥!');
            //this.$router.replace({path: '/'});
          }
        }, resp=> {
          this.loading = false;
          Message.error('用户非法⊙﹏⊙∥!');
          //this.$router.replace({path: '/'});
        });
    },
    // 取消挂单
    cancelSellItem: function(tradeItemId) {
      var queryData = {
        "id": tradeItemId
      };
      this.loading = true;
      postRequest('/map/tradeCenter/cancelSellItem', queryData).then(resp=> {
          if (resp.status == 200) {
            //成功
            var respData = resp.data;
            if (200 == respData.status) {
              Message.success("取消挂单成功！");
              this.getTradeCenterItems();
            } else {
              this.loading = false;
              Message.error(respData.message);
            }
          } else {
            //失败
            this.loading = false;
            Message.error('用户非法⊙﹏⊙∥!');
            //this.$router.replace({path: '/'});
          }
        }, resp=> {
          this.loading = false;
          Message.error('用户非法⊙﹏⊙∥!');
          //this.$router.replace({path: '/'});
        });
    },
    // 批量重新挂单
    reSellItems: function() {
      var queryData = {
        "centerId": 1
      };
      this.loading = true;
      postRequest('/map/tradeCenter/reSellItems', queryData).then(resp=> {
          if (resp.status == 200) {
            //成功
            var respData = resp.data;
            if (200 == respData.status) {
              Message.success("批量重新挂单成功！");
              this.getTradeCenterItems();
            } else {
              this.loading = false;
              Message.error(respData.message);
            }
          } else {
            //失败
            this.loading = false;
            Message.error('用户非法⊙﹏⊙∥!');
            //this.$router.replace({path: '/'});
          }
        }, resp=> {
          this.loading = false;
          Message.error('用户非法⊙﹏⊙∥!');
          //this.$router.replace({path: '/'});
        });
    },
    
  },
  beforeDestroy: function() {
  }
}
</script>

<style scoped>
a {
	cursor: pointer;
	color: blue;
}
.wrap {
    margin:auto;
}
.itembg {
    width:100%;
    height: 400px;
}
#itemtitle {
	padding:3px 5px;
	background-color:#72b653;
	font-size:16px;
	font-weight:bold;
	color:#fff;
	letter-spacing:5px;
	text-align:center;
}
/* 道具搜索 */
.itemSearch {
  height: 26px;
  line-height: 26px;
  font-size: 16px;
  vertical-align:middle;
  text-align: center;
  margin: 5px;
}
.itemSearch input {
	height: 26px;
  line-height: 26px;
	vertical-align:middle;
  text-align: center;
}
#itemlist {
	text-align:left;
  /* 解决div内容显示超过div高度的问题 */
  height:100%;
}
/* 商店中无道具时，提示语显示的样式 */
.noItems {
	padding:3px 5px;
	font-size:16px;
	font-weight:bold;
	letter-spacing:5px;
	text-align:center;
  height: 100px;
  line-height: 100px;
}
#itemlist .el-row {
  font-size: 14px;
}

#itemlist .shopItem {
  border-top:2px dotted green;
}
#itemlist .el-col span {
	height: 26px;
  line-height: 26px;
  vertical-align:middle;
}
#itemlist .el-col img {
	height: 26px;
  line-height: 26px;
  width: 26px;
  vertical-align:middle;
}
#itemlist .el-col .itemdesc {
  vertical-align:top;
}

.item {
    position:relative;
}
.item span {
    cursor: pointer;
    color: blue;
}
.item .opts {
    position:absolute;
    display: none;
    background-color: #b9f1b9;
    z-index: 10;
    width: 150px;
    text-align: center;
    border:1px solid #f00;
}
.item .opts a {
    display: block;
    padding: 5px;
    margin: auto;
    text-decoration: none;
}
.item .opts a:hover {
    text-decoration: underline;
    background-color: #666;
    color: #fff;
}
.item .opts {
    display:block;
    position:absolute;
    top:20px;
    left:50px;
}

/* ========== 移动端适配 ========== */
/* 桌面端默认：卡片列表隐藏，只显示表格 */
.tc-cards {
  display: none;
}

@media screen and (max-width: 768px) {
  .itembg {
    height: auto;
    min-height: 0;
  }
  /* 手机端改用卡片列表：表格整体隐藏（原「按 nth-child 隐藏列」方案会让
     表头隐藏 2/8 列、数据行隐藏 3/8 列，两者列数不一致 → 表头与数据永远错位） */
  .tc-table {
    display: none;
  }
  .tc-cards {
    display: block;
    margin-top: 6px;
  }
  .tc-card {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 2px;
    border-bottom: 1px dotted #8bc34a;
  }
  .tc-card:last-child {
    border-bottom: none;
  }
  .tc-thumb {
    width: 34px;
    height: 34px;
    flex: 0 0 34px;
    object-fit: contain;
    cursor: pointer;
  }
  .tc-body {
    flex: 1 1 auto;
    min-width: 0;
    cursor: pointer;
  }
  .tc-name {
    font-size: 13px;
    line-height: 1.35;
    color: #222;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .tc-name .trade-food-badge {
    font-size: 10px;
    margin-left: 2px;
  }
  .tc-meta {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 2px;
    font-size: 12px;
    color: #666;
  }
  .tc-meta .tc-price {
    color: #c62828;
    font-weight: bold;
    font-size: 13px;
  }
  .tc-sub {
    margin-top: 2px;
    font-size: 11px;
    color: #999;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .tc-sub .tc-dot {
    margin: 0 4px;
  }
  .tc-action {
    flex: 0 0 auto;
  }
  /* 按钮做成小胶囊，保证「取消挂单」四个字不换行 */
  .tc-btn {
    display: inline-block;
    padding: 5px 10px;
    border-radius: 14px;
    background: #72b653;
    color: #fff !important;
    font-size: 12px;
    line-height: 1.2;
    white-space: nowrap;
    text-decoration: none;
  }
  .tc-btn.tc-btn-cancel {
    background: #b65283;
  }
  .tc-disabled {
    font-size: 12px;
    color: #fff;
    background: #9e9e9e;
    padding: 5px 8px;
    border-radius: 14px;
    white-space: nowrap;
  }
  /* 卡片详情浮层 */
  .tc-detail-mask {
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0, 0, 0, 0.45);
    z-index: 9998;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .tc-detail-box {
    width: 74vw;
    max-width: 300px;
    background: #f7ffe9;
    border: 2px solid #72b653;
    border-radius: 10px;
    padding: 10px 12px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.35);
  }
  .tc-detail-title {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    font-weight: bold;
    color: #2e6b1f;
    padding-bottom: 6px;
    border-bottom: 1px solid #d8e8c0;
    margin-bottom: 6px;
  }
  .tc-detail-title img {
    width: 28px;
    height: 28px;
    object-fit: contain;
  }
  .tc-detail-line {
    font-size: 12px;
    line-height: 1.9;
    color: #444;
  }
  .tc-detail-close {
    margin-top: 10px;
    text-align: center;
    padding: 6px 0;
    background: #72b653;
    color: #fff;
    border-radius: 16px;
    font-size: 13px;
  }
  /* 道具详情浮窗移动端适配 */
  .item .opts {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 200px;
    z-index: 9999;
    box-shadow: 0 2px 12px rgba(0,0,0,0.3);
    border-radius: 6px;
  }
  /* 搜索栏 */
  .itemSearch {
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
  }
  .itemSearch input {
    flex: 1 1 auto;
    min-width: 0;
    max-width: 180px;
    box-sizing: border-box;
  }
  /* 「重新挂单」做成小胶囊，右对齐，别用裸蓝链接 */
  .tc-resell {
    display: block;
    width: 100%;
    text-align: right;
    margin: 2px 0 4px;
    text-decoration: none;
  }
  .tc-resell > span {
    display: inline-block;
    padding: 5px 12px;
    background: #fff6d6;
    border: 1px solid #e3c56e;
    border-radius: 14px;
    color: #8a6100 !important;
    font-size: 12px;
    line-height: 1.2;
  }
  /* 分页 */
  .pageDiv {
    padding: 8px 4px;
  }
}

/* 保鲜（perish_v1）：交易行新鲜度角标 */
.trade-food-badge {
  margin-left: 4px;
  font-size: 11px;
  padding: 0 4px;
  border-radius: 3px;
  color: #fff;
  font-weight: bold;
  vertical-align: middle;
}
.trade-food-badge.fresh { background-color: #4caf50; }
.trade-food-badge.expiring { background-color: #ff9800; }
.trade-food-badge.spoiled { background-color: #8d8d8d; }
</style>